var $messages;
var d, h, m;
var i = 0;
var socket;
var first_message_sent = false;

var loc = window.location;
var websocket_url;
var localhost_port = 3002;

if(loc.hostname === "localhost" || loc.hostname === "127.0.0.1") {
    websocket_url = 'ws://localhost:' + localhost_port;
} else {
    websocket_url = 'wss://' + loc.hostname;
}

var chat_greeting = "Welcome! I'm Prisma, the Apartment Lines chatbot -- I can answer many questions, ask away!";

jQuery(window).load(function() {
  if (!CHAT_ENABLED) {
    return;
  }
  setupSocket();
  $messages = jQuery('.avenue-messenger .messages-content');
  var $messageInput = jQuery('.avenue-messenger .message-input');
  var originalMessageInputHeight = $messageInput.height();
  $messages.mCustomScrollbar();
  setTimeout(function() {
    newMessage(chat_greeting);
  }, 100);

  function resetInputHeight() {
    $messageInput.height(originalMessageInputHeight); // Reset height to original
  }

  jQuery('#chat-icon').click(function(){
    jQuery('.avenue-messenger').show();
    if (!isTouchDevice()) {
      jQuery('.avenue-messenger .message-input').trigger('focus');
    }
    $messages.mCustomScrollbar("scrollTo", 'bottom');
    jQuery('#chat-icon').hide();
  });

  jQuery('.avenue-messenger .button').click(function(){
    jQuery('.avenue-messenger').hide();
    jQuery('#chat-icon').show();
  });

  $messageInput.on('input', function() {
    this.style.height = 'auto'; // Reset height to recalculate
    this.style.height = this.scrollHeight + 'px'; // Set height based on scroll height
  });

  jQuery('.avenue-messenger .message-submit').click(function() {
    insertMessage();
    resetInputHeight();
  });

  jQuery(window).on('keydown', function(e) {
    if (e.which == 13) {
      insertMessage();
      resetInputHeight();
      return false;
    }
  })
});

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0));
}

function setupSocket() {
   // Create a new WebSocket.
  var url = websocket_url + '/chat/';
  socket = new WebSocket(url);

  // Connection opened
  socket.addEventListener('open', function (event) {
      console.log('WebSocket is open now.');
  });

  // Listen for messages
  socket.addEventListener('message', function (event) {
    try {
      var data = JSON.parse(event.data);
    } catch (error) {
      console.error("Failed to parse JSON string:", error);
      return;
    }
    console.log('Message from server: ', data);
    if (data.success) {
      if (data.type == 'init') {
        newMessage()
      }
      else if (data.type == 'content') {
        if (data.data != '') {
          updateLastMessage(data.data)
        }
      }
    }
    else {
      errorMessage(data.message)
    }
  });

  // Connection closed
  socket.addEventListener('close', function (event) {
      console.log('Server closed connection: ', event);
  });

  // Connection error
  socket.addEventListener('error', function (event) {
      console.log('Error: ', event);
  });
}

function updateScrollbar() {
  $messages.mCustomScrollbar("update").mCustomScrollbar('scrollTo', 'bottom', {
    scrollInertia: 10,
    timeout: 0
  });
}

function setDate(){
  d = new Date()
  if (m != d.getMinutes()) {
    m = d.getMinutes();
    jQuery('<div class="timestamp">' + d.getHours() + ':' + String(m).padStart(2, '0') + '</div>').appendTo(jQuery('.avenue-messenger .message:last'));
    jQuery('<div class="checkmark-sent-delivered">&check;</div>').appendTo(jQuery('.avenue-messenger .message:last'));
    jQuery('<div class="checkmark-read">&check;</div>').appendTo(jQuery('.avenue-messenger .message:last'));
  }
}

function getMessage() {
  msg = jQuery('.avenue-messenger .message-input').val();
  if (jQuery.trim(msg) == '') {
    return false;
  }
  return msg;
}

function insertMessage() {
  var msg = getMessage();
  if (!msg) {
    return false;
  }
  jQuery('<div class="message message-personal">' + msg + '</div>').appendTo(jQuery('.avenue-messenger .mCSB_container')).addClass('new');
  setDate();
  jQuery('.avenue-messenger .message-input').val(null);
  updateScrollbar();
  newMessageLoading();
  updateScrollbar();
  sendMessage(msg);
  first_message_sent = true;
}

function sendMessage(msg) {
  var data = {
      "action": first_message_sent ? "followup-message" : "new-message",
      "token": CHAT_SERVER_TOKEN,
      "data": {
          "message": msg
      }
  };
  socket.send(JSON.stringify(data));
}

function newMessageLoading() {
  jQuery('<div class="message loading new"><figure class="avatar">' + PRISMA_AVATAR_IMG_TAG + '</figure><span></span></div>').appendTo(jQuery('.avenue-messenger .mCSB_container'));
  updateScrollbar();
}

function errorMessage(message = '') {
  newMessage(message + ', try reloading the page');
  var last_message = jQuery('.avenue-messenger .mCSB_container .message.new:last')
  last_message.addClass('error');
}

function newMessage(message = '') {
  message = message.replace(/\r?\n/g, '<br />');
  jQuery('.avenue-messenger .message.loading').remove();
  jQuery('<div class="message new"><figure class="avatar">' + PRISMA_AVATAR_IMG_TAG + '</figure><span class="message-contents">' + message + '</span></div>').appendTo(jQuery('.avenue-messenger .mCSB_container')).addClass('new');
  setDate();
  updateScrollbar();
}

function updateLastMessage(contents) {
  contents = contents.replace(/\r?\n/g, '<br />');
  var last_message = jQuery('.avenue-messenger .mCSB_container .message.new:last .message-contents')
  last_message.append(contents);
  updateScrollbar();
}
